import { create } from 'zustand';
import { MemberCreditData } from '../dto/EntityRepository';

interface MemberCreditState {
  credits: MemberCreditData[];
  setCredits: (credits: MemberCreditData[]) => void;
  clearCredits: () => void;
}

export const useMemberCreditStore = create<MemberCreditState>((set) => ({
  credits: [],
  setCredits: (credits) => set({ credits }),
  clearCredits: () => set({ credits: [] }),
}));
